// // import React, { useState } from "react";
// // import { CSVLink } from "react-csv";
// // import "bootstrap/dist/css/bootstrap.min.css";

// // export default function SitemapKeywordsTool() {
// //   const [url, setUrl] = useState("");
// //   const [loading, setLoading] = useState(false);
// //   const [results, setResults] = useState([]);

// //   const handleScrape = async () => {
// //     if (!url.trim()) {
// //       alert("Please enter a valid sitemap URL or domain.");
// //       return;
// //     }

// //     setLoading(true);
// //     setResults([]);

// //     try {
// //       const response = await fetch("http://185.126.181.19:5000/api/sitemap-keywords", {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ url }),
// //       });

// //       if (!response.ok) {
// //         throw new Error("Failed to scrape keywords.");
// //       }

// //       const data = await response.json();
// //       setResults(data.data);
// //     } catch (error) {
// //       console.error("Error:", error.message);
// //       alert("An error occurred while scraping. Please try again.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const csvHeaders = [
// //     { label: "URL", key: "url" },
// //     { label: "Keywords", key: "keywords" },
// //     { label: "Word Count", key: "wordCount" },
// //   ];

// //   const exportData = results.map((item) => ({
// //     url: item.url,
// //     keywords: item.keywords.join(", "),
// //     wordCount: item.wordCount,
// //   }));

// //   return (
// //     <div className="container py-5">
// //       <div className="text-center mb-4">
// //         <h2>🛠 Scrape Competitor's Keywords</h2>
// //         <p className="text-muted">
// //           Extract keywords from all links in a sitemap and display them below.
// //         </p>
// //       </div>

// //       {/* Input Section */}
// //       <div className="row justify-content-center mb-4">
// //         <div className="col-md-6">
// //           <div className="input-group">
// //             <input
// //               type="text"
// //               className="form-control"
// //               placeholder="Enter Sitemap URL or Domain"
// //               value={url}
// //               onChange={(e) => setUrl(e.target.value)}
// //             />
// //             <button
// //               className="btn btn-primary"
// //               onClick={handleScrape}
// //               disabled={loading}
// //             >
// //               {loading ? "Scraping..." : "Scrape"}
// //             </button>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Loading Spinner */}
// //       {loading && (
// //         <div className="text-center">
// //           <div className="spinner-border text-primary" role="status">
// //             <span className="visually-hidden">Loading...</span>
// //           </div>
// //           <p className="mt-3">Fetching sitemap and scraping keywords...</p>
// //         </div>
// //       )}

// //       {/* Results Section */}
// //       {!loading && results.length > 0 && (
// //         <div className="card shadow-sm">
// //           <div className="card-header d-flex justify-content-between align-items-center">
// //             <h5>Keywords ({results.length})</h5>
// //             <CSVLink
// //               data={exportData}
// //               headers={csvHeaders}
// //               filename="sitemap_keywords.csv"
// //               className="btn btn-success btn-sm"
// //             >
// //               Export CSV
// //             </CSVLink>
// //           </div>
// //           <div className="table-responsive">
// //             <table className="table table-striped table-hover mb-0">
// //               <thead className="table-dark">
// //                 <tr>
// //                   <th>#</th>
// //                   <th>URL</th>
// //                   <th>Keywords</th>
// //                   <th>Word Count</th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {results.map((item, index) => (
// //                   <tr key={index}>
// //                     <td>{index + 1}</td>
// //                     <td>{item.url}</td>
// //                     <td>{item.keywords.join(", ")}</td>
// //                     <td>{item.wordCount}</td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }
import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const App = () => {
  const [url, setUrl] = useState("");
  const [formats, setFormats] = useState([]);
  const [thumbnail, setThumbnail] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(5); // Countdown state
  const [activeTab, setActiveTab] = useState("video"); // Active tab state

  useEffect(() => {
    let timer;
    if (loading) {
      setCountdown(5); // Reset countdown to 5 seconds
      timer = setInterval(() => {
        setCountdown((prev) => (prev > 1 ? prev - 1 : 0));
      }, 1000);
    } else {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [loading]);

  // Fetch formats based on YouTube URL
  const fetchFormats = async () => {
    setError("");
    setFormats([]);
    setThumbnail("");
    setVideoTitle("");

    if (!url) {
      setError("Please enter a valid YouTube URL.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post("https://ytd.mhnazmul.com/getFormats", { url });
      setFormats(response.data.formats);
      setThumbnail(response.data.thumbnail);
      setVideoTitle(response.data.videoTitle);
    } catch (err) {
      setError("Error fetching video formats.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (type, itag) => {
    const downloadUrl = `https://ytd.mhnazmul.com/download${type}?url=${encodeURIComponent(
      url
    )}&itag=${itag}`;
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

console.log(formats);

  return (
    <div className="container">
      <div className="">
        <div className="card-body text-center">
        
          {/* Input and Button */}
          <form className="row mx-auto m-5 g-3 justify-content-center align-items-center" style={{maxWidth:"800px" }}>
  {/* Input Field */}
  <div className="col-12 col-md-10">
    <div className="input-group" style={{ height: "60px" }}>
      {/* YouTube Icon */}
      <span
        className="input-group-text bg-light"
        style={{
          borderRight: "0", // Removes the right border
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src="https://img.icons8.com/color/48/000000/youtube-play.png"
          alt="YouTube Icon"
          style={{ width: "48px", height: "48px" }}
        />
      </span>
      {/* Input Box */}
      <input
        type="text"
        className="form-control"
        placeholder="https://www.youtube.com/watch?v=..."
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{
          backgroundColor: "#f7f9fc",
          border: "1px solid #d9dfe7",
          borderLeft: "0", // Removes the left border between icon and input
          fontSize: "1rem",
          padding: "0.8rem 1rem",
          borderRadius: "0 5px 5px 0", // Rounded corners for right side
        }}
      />
    </div>
  </div>

  {/* Search Button */}
  <div className="col-12 col-md-2">
    <button
      type="button"
      className="btn w-100"
      onClick={fetchFormats}
      disabled={loading}
      style={{
        backgroundColor: "#5b4ee6",
        color: "#fff",
        fontSize: "1rem",
        padding: "0.7rem 1.5rem",
        height: "60px",
        borderRadius: "5px",
      }}
    >
      {loading ? `Loading... ${countdown}s` : "Search"}
    </button>
  </div>
</form>


          {error && (
            <div className="alert alert-danger mt-3" role="alert">
              {error}
            </div>
          )}

          {thumbnail && (
            <div className="mx-auto" style={{maxWidth:"800px" }}>
              <img
                src={thumbnail}
                alt="Video Thumbnail"
                className="img-fluid rounded shadow"
                style={{
                  maxHeight: "300px",
                  objectFit: "cover",
                  width: "100%",
                  borderRadius: "0.5rem",
                }}
              />
              <h3 className="m-3">{videoTitle}</h3>
            </div>
          )}

{formats.length > 0 && (
  <div className="m-4">
    <h5 className="text-center">Available Audio Formats</h5>
    <div className="row justify-content-center">
      {formats
        .filter((format) => format.type === "audio") // Show only audio formats
        .map((format, index) => (
          <div className="col-md-6 col-lg-4 mb-3" key={index}>
            <div
              className="card"
              style={{ minWidth: "300px", textAlign: "center" }}
            >
              <div className="card-body d-flex flex-column justify-content-between align-items-center">
                {/* Audio Format Label */}
                <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                  {`${format.qualityLabel || "Audio"} (mp3)`}
                </span>

                {/* Download Button */}
                <button
                className="btn btn-primary"
                
                  style={{
                    backgroundColor: "#5b4ee6",
                    color: "#fff",
                    fontSize: "1rem",
                    padding: "0.7rem 1.5rem",
                    borderRadius: "5px",
                  }}
                  onClick={() =>
                    handleDownload(format.type === "audio" ? "Audio" : "Video", format.itag)
                  }
                >
                   Download
                  </button>
              </div>
            </div>
          </div>
        ))}
    </div>
  </div>
)}


        </div>
      </div>
    </div>
  );
};

export default App;
